/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Set_Name_LabelInputs */

const en_tags_manager_set_name_label = /** @type {(inputs: Tags_Manager_Set_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Name`)
};

const fr_tags_manager_set_name_label = /** @type {(inputs: Tags_Manager_Set_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de l'ensemble`)
};

const de_tags_manager_set_name_label = /** @type {(inputs: Tags_Manager_Set_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set-Name`)
};

const it_tags_manager_set_name_label = /** @type {(inputs: Tags_Manager_Set_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta nome`)
};

const ru_tags_manager_set_name_label = /** @type {(inputs: Tags_Manager_Set_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название набора`)
};

const es_tags_manager_set_name_label = /** @type {(inputs: Tags_Manager_Set_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del conjunto`)
};

const zh_cn2_tags_manager_set_name_label = /** @type {(inputs: Tags_Manager_Set_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置名称`)
};

const ja_tags_manager_set_name_label = /** @type {(inputs: Tags_Manager_Set_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セット名`)
};

const hi_tags_manager_set_name_label = /** @type {(inputs: Tags_Manager_Set_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेट नाम`)
};

const pt_pt2_tags_manager_set_name_label = /** @type {(inputs: Tags_Manager_Set_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do conjunto`)
};

/**
* | output |
* | --- |
* | "Set Name" |
*
* @param {Tags_Manager_Set_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_set_name_label = /** @type {((inputs?: Tags_Manager_Set_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Set_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_set_name_label(inputs)
	if (locale === "de") return de_tags_manager_set_name_label(inputs)
	if (locale === "it") return it_tags_manager_set_name_label(inputs)
	if (locale === "ru") return ru_tags_manager_set_name_label(inputs)
	if (locale === "es") return es_tags_manager_set_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_set_name_label(inputs)
	if (locale === "ja") return ja_tags_manager_set_name_label(inputs)
	if (locale === "hi") return hi_tags_manager_set_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_set_name_label(inputs)
	return en_tags_manager_set_name_label(inputs)
});